import { FooterTools } from './footerTools';
import { Loader } from './loader';
import { TextSelector } from './textSelector';
declare let defaultDbTextSelector: TextSelector;

export class Spin {
  public static showSpin(
    text: string,
    decoration = '',
    options?: {
      subtitleHtml?: string;
      subtitleTextId?: string;
      detailsHtml?: string;
      detailsTitleTextId?: string;
      showRestartButton?: boolean;
      restartButtonTextId?: string;
    },
  ) {
    const titleText = defaultDbTextSelector.getText(text).text_presentation;
    const subtitleHtml =
      options?.subtitleHtml ||
      (options?.subtitleTextId
        ? defaultDbTextSelector.getText(options.subtitleTextId)
            .text_presentation
        : '');
    const detailsTitle = options?.detailsTitleTextId
      ? defaultDbTextSelector.getText(options.detailsTitleTextId)
          .text_presentation
      : '';
    const detailsHtml = (detailsTitle || '') + (options?.detailsHtml ?? '');
    const restartButtonText = options?.restartButtonTextId
      ? defaultDbTextSelector.getText(options.restartButtonTextId)
          .text_presentation
      : '';
    Loader.loadContentWithVersion(
      '#main',
      'template/spin-template.mst',
      {
        titleText,
        decoration: decoration,
        subtitleHtml: subtitleHtml || null,
        detailsHtml: detailsHtml || null,
        showRestartButton: options?.showRestartButton,
        restartButtonText,
      },
      () => {
        FooterTools.addTools({
          powered: false,
          lange: false,
          speaker: false,
          mode: true,
          help: true,
          version: false,
          fullscreen: true,
          refresh: false,
        });
      },
    );
  }
}
